export const routes = (prefix = `claims`) => [
    {
        path: `/${prefix}/batching`,
        name: `${prefix}.batching.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.batching.index`,
                PageDescription: "Claims: Batching",
            },
        },
    },{
        path: `/${prefix}/raisedclaims`,
        name: `${prefix}.batching.raisedclaims`,
        component: () => import('./Claims.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.batching.claims`,
                PageDescription: "Claims: Raised Claims",
            },
        },
    },
];